export const htmlContent = `<!DOCTYPE html>
<html>
<head>
    <style>
        body {
            font-family: Calibri, sans-serif;
        }
        .container-container {
            counter-reset: container; /* Reset counter for numbering */
        }
        .container {
            background-color: #f0f0f0;
            padding: 10px;
            margin: 5px 0;
            border-radius: 5px;
            border: 1px solid #dcdcdc; /* Darker border color */
            position: relative; /* To position the number inside the container */
            padding-left: 50px; /* Increased space for the number */
        }
        .container::before {
            content: counter(container) ".";
            counter-increment: container;
            position: absolute;
            left: 10px;
            top: 50%;
            transform: translateY(-50%); /* Center the number vertically */
            width: 30px;
            height: 30px;
            border-radius: 50%;
            background: linear-gradient(to bottom, red 50%, blue 50%); /* Half red, half blue */
            color: #fff; /* White color for the number */
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
        }
        .affected-roles {
            font-style: italic;
            color: red;
            font-size: smaller;
        }
    </style>
</head>
<body>

<b>Release Date: 15 September 2024</b><br>
<div class="container-container">
    <div class="container">
        <p><b>Blood Donor List:</b> : In this version, the new module Blood Donor List has been included. The circle office can now flag the prisoner who is an active blood donor in the prison.
        <br><span class="affected-roles">Affected Roles: Circle Office, Superintendent/DSP, DIGs, IG</span></p>
    </div>

    <div class="container">
        <p><b>Dependents’ Pictures:</b> Now the relevant branch can add the pictures of the accompanying dependents. Previously, only Name, Relationship, Age and remarks fields were given, now the pictures can also be uploaded or captured.
		<br><span class="affected-roles">Affected Roles: UTP/Convict, Superintendent/DSP, DIGs, IG.</span></p>
    </div>
	</div>

    <div class="container">
        <p><b>Upcoming Retirements:</b> Now in HR, a list of upcoming retirements will be shown. This will give an idea of the retiring employees, which will help management make quick and flawless planning for the future. Also, the retirement date has to be added in the profile of the employee by HR.
		<br><span class="affected-roles">Affected Roles: DarbanHR, Superintendent/DSP, DIGs, IG. 
</div>
</div>
    <div class="container">
        <p><b>Disciplinary Action/Penalties imposed:</b> In the HR module, another field is given where the record of the disciplinary action/penalties record can be kept for future reference.
        <br><span class="affected-roles">Affected Roles: HR, Superintendent/DSP, DIGs, IG</span></p>
    </div>

    <div class="container">
        <p><b>Injury/Unexplained Injury:</b>A field to enter the unexplained injury has been given in the add medical details (Medical Examination). Now the record of the unexplained injuries at the time of admission can be kept.
        <br><span class="affected-roles">Affected Roles: Hospital, Superintendent/DSP, DIGs, IG.</span></p>
    </div>
    <div class="container">
        <p><b>Read-More Option:</b>A read more option has been given in the grids where the under sections and acts are being displayed. Previously when a prisoner used to have too many under sections applied on them it was expanding the grid making it look weird. Now if more under sections are added, the system will show just a few by default and others will be accessible when “Read More” is clicked. .
        <br><span class="affected-roles">Affected Roles: All Roles</span></p>
    </div>

    <div class="container">
        <p><b>Posting History Field:</b> Another field of the previous posting history is enabled in the profile management in the HR module. Now the record of the posting history can be managed in the profile of the employee for future reference. 
        <br><span class="affected-roles">Affected Roles: HR, Superintendent/DSP, DIGs, IG.</span></p>
    </div>

    <div class="container">
        <p><b>Complaint Record:</b>The complaint record of the employee can now be entered and referred to in the profile of the employee. This option has been added in the profile creation form under the HR branch.
        <br><span class="affected-roles">Affected Roles: HR, Superintendent/DSP, DIGs, IG.</span></p>
    </div>

    <div class="container">
        <p><b>Details of Promotions:</b> The details of the promotion can be added to the profile of the employes under the HR branch. This text area will help keep track of all the employees’ promotions and will allow management to make decisions based on it. .
        <br><span class="affected-roles">Affected Roles: HR, Superintendent/DSP, DIGs, IG.</span></p>
    </div>

    <div class="container">
        <p><b>Case Edit Option:</b> The some of the fields have been now enabled for editing in the cases. This will help sort out little mistakes that employees might make while adding the cases.
        <br><span class="affected-roles">Affected Roles: UTP/Convict</span></p>
    </div>

    <div class="container">
        <p><b>Details of Promotions:</b> The details of the promotion can be added to the profile of the employes under the HR branch. This text area will help keep track of all the employees’ promotions and will allow management to make decisions based on it. .
        <br><span class="affected-roles">Affected Roles: Admin, HR</span></p>
    </div>


</div>
</div>
</body>
</html>`;
